import { Action } from '@agile-actors/actions/js';

const namespaceAction = Action('@@UI/LAYOUT');

const scroll = namespaceAction('SCROLL');

export { scroll };
